"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.vehicleImagePropType = exports.productTilePropType = exports.header350PropType = exports.dataPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var header350PropType = exports.header350PropType = _propTypes["default"].shape({
  mainHeading: _propTypes["default"].string,
  paragraph: _propTypes["default"].string,
  textAlignment: _propTypes["default"].string,
  theme: _propTypes["default"].string
});
var vehicleImagePropType = exports.vehicleImagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
var productTilePropType = exports.productTilePropType = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  vehicleImage: vehicleImagePropType,
  name: _propTypes["default"].string
}));
var dataPropType = exports.dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  productTile: productTilePropType,
  disclaimerData: _text.disclaimerDataPropTypes,
  addPriceDisclaimer: _propTypes["default"].bool,
  priceDisclaimerId: _propTypes["default"].string
});